import { createColumnHelper } from '@tanstack/react-table';

import { ServiceAccount } from '../../types';

export const columnHelper = createColumnHelper<ServiceAccount>();
